import React, { useEffect, useState, useRef } from 'react';
import Icon from './iconcomponent'
// import folder from '../images/folder'
import folder_image from '../images/folder2.png'

const requestAnimationFrame = window.requestAnimationFrame
  || window.mozRequestAnimationFrame
  || window.webkitRequestAnimationFrame
  || window.msRequestAnimationFrame;
const cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame;

const Test = () => {
  const [isDragging, setDragging] = useState(false);
  const block = useRef(null);
  const frameID = useRef(0);
  const lastX = useRef(0);
  const lastY = useRef(0);
  const dragX = useRef(0);
  const dragY = useRef(0);

  const handleMove = (e) => {
    if (!isDragging) {
      return;
    }

    const deltaX = lastX.current - e.pageX;
    const deltaY = lastY.current - e.pageY;
    lastX.current = e.pageX;
    lastY.current = e.pageY;
    dragX.current -= deltaX;
    dragY.current -= deltaY;

    cancelAnimationFrame(frameID.current);
    frameID.current = requestAnimationFrame(() => {
      block.current.style.transform = `translate3d(${dragX.current}px, ${dragY.current}px, 0)`;
    });
  };

  const handleMouseDown = (e) => {
    lastX.current = e.pageX;
    lastY.current = e.pageY;
    setDragging(true);
  };

  const handleMouseUp = () => {
    setDragging(false);
  };

  /**
   *
   */
  useEffect(() => {
    document.addEventListener('mousemove', handleMove);
    document.addEventListener('mouseup', handleMouseUp);

    return () => {
      document.removeEventListener('mousemove', handleMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging]);

  const iconsData = [
    {
      imageName: 'iconNames',
      iconLink: '/link1',
      iconName: 'Icon 1',
    },
    {
      imageName: 'windows',
      iconLink: '/link2',
      iconName: 'Icon 2',
    },
    // Add more icon data objects as needed
  ];

  return (
    <div 
      ref={block}
      onMouseDown={handleMouseDown}
      style={{ height: 100, width: 100, border: '1px solid red' }}
    >

    <div className="icon-group">
          {iconsData.map((iconData, index) => (
          <Icon
              key={index}
              imageName={iconData.imageName}
              iconLink={iconData.iconLink}
          />
          ))}
      </div>

     <Icon 
        imageName='sample' 
        iconLink={folder_image}
        iconName="Example Icon" 
     />
     Title

    </div>
  );
};

export default Test;